<template lang="pug">

	Button.-s-(
		:href="currectLink"
		:target="content.isBlank ? '_blank' : null"
	) {{content.buttonText}}

</template>

<script>
export default {
  props: {
    content: {}
  },
  computed: {
    currectLink() {
      const isHref = /https:\/\//.test(this.content.buttonUrl);
      let linkEdited;

      if (isHref) {
        linkEdited = this.content.buttonUrl;
      } else {
        linkEdited = `https://${this.content.buttonUrl}`;
      }

      return linkEdited;
    }
  }
};
</script>
